import { InputPlugin } from "./plugins/InputPlugin";
import { LocalDeviceEvent } from "./LocalDevice";
import { LocalMediaEvent } from "./LocalMediaManager";
import { GatherEventEmitter } from "gather-common-including-video/dist/src/public/GatherEventEmitter";
import { newLocalAudioDevice } from "./SpecificLocalDevices";
import { TrackPipeline } from "./TrackPipeline";
export class AudioManager extends GatherEventEmitter {
    device = newLocalAudioDevice();
    muteDesired = true;
    pauseOnMute = false;
    pipeline = new TrackPipeline(new InputPlugin("audio", this.device));
    production;
    start(plugins, production) {
        this.production = production;
        if (!this.muteDesired) {
            this.production.unmute();
        }
        const cleanupCallbacks = [
            this.device.addEventListener(LocalDeviceEvent.StreamChanged, () => {
                this.updateMuted();
            }),
            this.pipeline.build([...plugins, this.production]),
            this.device.start(),
        ];
        return () => cleanupCallbacks.forEach((c) => c());
    }
    async changeSettings(settings, reload = true) {
        await this.device.changeSettings(settings, reload);
    }
    isMuteDesired() {
        return this.muteDesired;
    }
    async mute() {
        this.muteDesired = true;
        this.production?.mute();
        if (!this.pauseOnMute) {
            await this.device.mute();
        }
        this.updateMuted();
    }
    async unmute() {
        this.muteDesired = false;
        this.production?.unmute();
        await this.device.unmute();
        this.updateMuted();
    }
    async setPauseOnMute(pauseOnMute) {
        this.pauseOnMute = pauseOnMute;
        if (this.muteDesired && pauseOnMute) {
            await this.device.unmute();
        }
        else if (this.muteDesired && !pauseOnMute) {
            await this.device.mute();
        }
    }
    updateMuted() {
        let muted;
        if (this.pauseOnMute) {
            muted = !this.device.active() || !!this.production?.muted();
        }
        else {
            muted = !this.device.active();
        }
        this.publishEvent(LocalMediaEvent.MuteChanged, muted);
    }
    resetPipeline() {
        const track = this.device.audioTrack;
        if (track) {
            this.pipeline.input.plugin.trackChanged(undefined);
            this.pipeline.input.plugin.trackChanged(track);
        }
    }
    debugInfo() {
        return this.pipeline.debugInfo();
    }
}
//# sourceMappingURL=AudioManager.js.map